import { IconBookmark } from '@spotify-internal/encore-web';
import {
  type FilterDefinition,
  ToggleFilterChip,
  createToggleFilter,
  useFilters,
} from '@spotify/confidence-core-react';
import { useFeatureFlag } from '@spotify/confidence-flag-evaluation-react';

export const FAVORITES_FILTER = createToggleFilter({
  id: 'favorites',
  label: 'Favorites',
  iconLeading: IconBookmark,
  query: () => '',
  viewer: ToggleFilterChip,
});

export const useFavoritesFilter = (): FilterDefinition | undefined => {
  const { enabled } = useFeatureFlag('collections', { enabled: false });
  return enabled ? FAVORITES_FILTER : undefined;
};

export const useFavoritesFilterToggle = () => {
  const { activeFilters, addFilter, removeFilter } = useFilters();
  const isActive = activeFilters.some(f => f.id === FAVORITES_FILTER.id);
  const toggle = () => {
    if (isActive) {
      removeFilter(FAVORITES_FILTER.id);
    } else {
      addFilter(FAVORITES_FILTER, true);
    }
  };

  return { isActive, toggle };
};
